import styled from 'styled-components';

export const FilterContainerStyled = styled.div<{ $isCollapsed: boolean }>`
  display: ${({ $isCollapsed }) => ($isCollapsed ? 'none' : 'block')};
`;
